module.exports = __webpack_public_path__ + "static/media/licenta31.bb687a44.png";